<div class="fm-warraper" id="ngx_fm">
  <div class="details-commands-panel row">
    <div class="col-sm-9">
      <ol *ngIf="fileExplorerService.headerData.length" class="breadcrumb">
        <li [ngClass]="{'active': pl.isActive}" *ngFor="let pl of fileExplorerService.headerData">
          <a *ngIf="!pl.isActive ,else elseBlock" (click)="fileExplorerService.setSelected(pl.node)">{{pl.name}}</a>
          <ng-template #elseBlock>{{pl.name}}</ng-template>
        </li>
      </ol>
    </div>
    <div class="col-sm-3">
      <div class="actions-command-panel">
        <a href="javascript:void(0);" (click)="fileExplorerService.toggleView()"
           [title]="'Screens.FileExplorer.Actions.ChangeView' | translate">
          <i class="fa"
             [ngClass]="{'fa-th-list': !fileExplorerService.IsListMode,'fa-th': fileExplorerService.IsListMode}"></i>
        </a>
        <ng-container *ngIf="canEdit">
          <a href="javascript:void(0);" [title]="'Screens.FileExplorer.Actions.UploadFile' | translate"
             [routerLink]="['/patients/details/patient-document-details', {mode: 'modal', size: 'md'}]"
             [queryParams]="{patientId: fileExplorerService.patientId, virtualFolderPath: fileExplorerService.selected.path}">
            <i class="fa fa-upload"></i>
          </a>
          <a href="javascript:void(0);" (click)="openAddFolderPopup()"
             [title]="'Screens.FileExplorer.Actions.CreateFolder' | translate">
            <i class="fa fa-plus"></i>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="docs-content-wrapper">
    <div class="sidebar scrollable-content">
      <filemanager-dir-tree></filemanager-dir-tree>
    </div>
    <div class="main scrollable-content">
      <explorer-view [canEdit]="canEdit"></explorer-view>
    </div>
  </div>
</div>

<ng-template #createFolderModalTemplate let-data="data" let-form="form">
  <div class="row" [dynamicFormProvider]="form">
    <div class="col-sm-9" *ngIf="form">
      <waf-text-input
                      #folderNameTextInput
                      [fileNameAlreadyExistsValidator]="{isFile: false, name: ''}"
                      fileNameContainSpecificSymbolsValidator
                      name="folderName"
                      [label]="'Screens.FileExplorer.Fields.FolderName' | translate"
                      [(ngModel)]="data.folderName"
                      [placeholder]="'Screens.FileExplorer.Fields.FolderName' | translate"
                      [maxLength]="100"></waf-text-input>
    </div>
  </div>
</ng-template>